var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stringwave w-full h-full"},[_c('svg',{staticClass:"chart w-full",attrs:{"viewBox":"0 0 365 50"}},[_c('path',{attrs:{"fill":"None","id":"wave3","d":_vm.generatedPath,"stroke":_vm.waveColor,"stroke-width":"2px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }